import { Divider, Empty, Space } from 'antd';
import { useRouter } from 'next/router';
import { INewsItemDetail } from 'types/news';

import styles from './PressReleaseDetailCard.module.css';
import classNames from 'classnames/bind';

import dayjs from 'dayjs';
import DOMPurify from 'isomorphic-dompurify';

import GoToBackButton from 'components/common/GotoBackButton';
import NewsSectionTab from '../NewsSectionTab';

const cx = classNames.bind(styles);

interface IPressReleaseDetailCardProps {
  newsData: INewsItemDetail;
}
function PressReleaseDetailCard({ newsData }: IPressReleaseDetailCardProps) {
  const router = useRouter();
  const { page, search } = router.query;
  const sanitizer = DOMPurify.sanitize;
  const handleGotoListPage = () =>
    router.push(
      `/news/pr?page=${page || 1}${search ? `&search=${search}` : ''}`
    );
  const { title, displayDate, content } = newsData.data.attributes;
  return (
    <Space
      direction="vertical"
      size="middle"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <NewsSectionTab />

      <div className={cx('wrapper')}>
        <section className={cx('header')}>
          <h1 className={cx('title')}>{title}</h1>
          <span className={cx('date')}>
            {dayjs(displayDate).format('YYYY.MM.DD')}
          </span>
        </section>
        <Divider />
        <section className={cx('content-wrapper')}>
          <div
            key={title}
            dangerouslySetInnerHTML={{
              __html: sanitizer(content || '등록된 콘텐츠 내용이 없습니다.'),
            }}
          />
        </section>
        <GoToBackButton onClick={handleGotoListPage} />
      </div>
    </Space>
  );
}

export default PressReleaseDetailCard;
